var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"closeWeb"}},[_c('h1',{staticClass:"closeMsg"},[_vm._v("管理员已关闭网站，请与管理员联系")])])
}]

export { render, staticRenderFns }